module.exports = __webpack_public_path__ + "img/shipped.0b841f5d.png";